module.exports = __webpack_public_path__ + "img/index-2.0290b313.png";